import { Card, CardContent } from "@/components/ui/card";
import { formatUi } from "@/lib/excel/format";
import { OutputsSnapshot } from "@/types/excel/types";

type Props = {
  disabled?: boolean;
  outputs: OutputsSnapshot;
};

export function ResultsPanel({ disabled, outputs }: Props) {
  if (disabled) {
    return (
      <p className="mt-4 text-sm text-muted-foreground">
        Upload a workbook to see results.
      </p>
    );
  }

  if (!outputs.length) {
    return (
      <p className="mt-4 text-sm text-muted-foreground">
        No output cells configured yet.
      </p>
    );
  }

  return (
    <div className="mt-4 grid gap-3 md:grid-cols-2">
      {outputs.map((o) => (
        <Card key={o.key}>
          <CardContent className="p-5">
            <div className="text-sm text-muted-foreground">{o.label}</div>
            <div className="mt-1 text-2xl font-semibold tracking-tight">
              {formatUi(o.value, o.format)}
            </div>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
